<script setup lang="ts">
defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();
</script>

<template>
  <RouterLink
    v-if="field && rowData.adoption_requests"
    :to="`/shelter/adoptions/animal/requests/${rowData.animal_id.$oid}`"
  >
    <p
      class="w-6 rounded-full bg-red-500 p-1 text-center text-xs text-white transition-colors hover:bg-red-600 active:bg-red-700"
    >
      {{ field }}
    </p>
  </RouterLink>

  <p
    v-else-if="field"
    class="w-6 rounded-full bg-red-500 p-1 text-center text-sm text-white transition-colors hover:bg-red-600 active:bg-red-700"
  >
    {{ field }}
  </p>

  <p v-else>-</p>
</template>
